var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor"},[_c('el-input',{attrs:{"value":_vm.value,"type":"textarea","rows":_vm.rows,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_vm._v(" "),_c('p',{staticClass:"rich-text-editor__hint"},[_vm._v("支持 HTML 富文本；前台详情页将原样渲染。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }